<template>
    <div id="dashboard-analytics">
        <h3>Relatório Produtividade</h3>
        <span>Aqui você pode extrair uma tabela ou planilha com o relatório de uso da plataforma dos seus atendentes</span>

        <vs-tabs v-model="currentTab">
            <vs-tab :label="nameTab" v-for="( nameTab ) in types" :key="nameTab" >
                <vs-card class="vx-col w-full md:w-1/1 lg:w-1/1 xl:w-1/1 mb-base" id="vs-card">
                    <div class="w-full flex justify-left items-center">
                        <span style="margin: 2%; font-size: 120%"><b>Filtrar dados por periodo:</b></span>
                        <flat-pickr
                                class="ml-8"
                                :config="initialConfigdateTimePicker"
                                v-model="initial_date"
                                ref="initial"
                                placeholder="Intervalo inicial"
                        />
                        <flat-pickr
                                class="ml-8"
                                :config="finalConfigdateTimePicker"
                                v-model="finish_date"
                                ref="final"
                                placeholder="Intervalo final"
                        />

                        <div class="ml-8" >
                            <div class="w-64 w-12/12" v-if="nameTab !== 'Campanha WhatsApp' && nameTab !== 'Campanha Sms' && nameTab !== 'Campanha Email'">
                                <vs-radio class="mr-2" v-model="reportUser" vs-name="reportUser" vs-value="all">
                                    Todos Operadores
                                </vs-radio>
                                <vs-radio v-model="reportUser" vs-name="reportUser" vs-value="specific">
                                    Operador Específico
                                </vs-radio>
                            </div>
                        </div>

                        <vs-button
                            class="w-75"
                            @click="filterDateAnalytics()"
                            :disabled="buttonDisabled"
                        >
                            Filtrar
                        </vs-button>
                    </div>
                </vs-card>
            </vs-tab>
<!--            <vs-tab label="Sincronização Manual">-->
<!--                <vs-card class="vx-col w-full md:w-1/1 lg:w-1/1 xl:w-1/1 mb-base" id="vs-card">-->
<!--                    <div class="w-full">-->
<!--                        <div class="mb-5">-->
<!--                            <h6 class="text-center mb-2">Atualização dos Relatórios</h6>-->
<!--                            <span class="flex justify-center" style="font-size: 120%" >-->
<!--                                Caso verifique que os dados no relatório estão desatualizados, basta informar a data desejada-->
<!--                                e solicitar a sincronização.-->
<!--                              </span>-->
<!--                        </div>-->

<!--                        <div class="d-flex w-full flex-wrap" style="justify-content: center">-->
<!--                            <div class="w-12/12 m-2">-->
<!--                                <div class="w-full justify-center items-center">-->
<!--                                    <span class="phone-number-span mr-12">-->
<!--                                      Período (de)-->
<!--                                    </span>-->
<!--                                </div>-->

<!--                                <div class="w-full">-->
<!--                                    <flat-pickr-->
<!--                                        :config="initialConfigdateTimePicker"-->
<!--                                        v-model="initial_date"-->
<!--                                        v-validate="'required'"-->
<!--                                        name="Período (de)"-->
<!--                                        placeholder="Escolha um dia"-->
<!--                                    />-->

<!--                                    <div class="clear: both;">-->
<!--                                      <span-->
<!--                                          class="text-danger text-sm"-->
<!--                                          v-show="errors.has('Período (de)')"-->
<!--                                      >-->
<!--                                        {{ errors.first('Período (de)') }}-->
<!--                                      </span>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->

<!--                            <div class="w-12/12 m-2">-->
<!--                                <div class="w-full justify-center items-center">-->
<!--                                    <span class="phone-number-span mr-12">-->
<!--                                      Período (até)-->
<!--                                    </span>-->
<!--                                </div>-->

<!--                                <div class="w-full">-->
<!--                                    <flat-pickr-->
<!--                                        :config="finishAtConfig(initialConfigdateTimePicker)"-->
<!--                                        :disabled="initial_date === ''"-->
<!--                                        v-model="finish_date"-->
<!--                                        v-validate="'required'"-->
<!--                                        name="Período (até)"-->
<!--                                        placeholder="Escolha um dia"-->
<!--                                    />-->

<!--                                    <div class="clear: both;">-->
<!--                                      <span-->
<!--                                          class="text-danger text-sm"-->
<!--                                          v-show="errors.has('Período (até)')"-->
<!--                                      >-->
<!--                                        {{ errors.first('Período (até)') }}-->
<!--                                      </span>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->

<!--                            <div class="w-12/12 m-2">-->
<!--                                <div class="w-full justify-center items-center">-->
<!--                                    <span class="phone-number-span mr-12">-->
<!--                                      Tipo-->
<!--                                    </span>-->
<!--                                </div>-->

<!--                                <select v-model="typeSelected" class="bg-white pb-4 pr-10 input-select-con input-select vs-select&#45;&#45;input">-->
<!--                                    <option v-for="item in typeFilter" :key="item" :value="item" class="vs-select&#45;&#45;item">{{item}}</option>-->
<!--                                </select>-->

<!--                                <div class="clear: both;">-->
<!--                                    <span-->
<!--                                        class="text-danger text-sm"-->
<!--                                        v-show="errors.has('Tipo')"-->
<!--                                    >-->
<!--                                      {{ errors.first('Tipo') }}-->
<!--                                    </span>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->

<!--                        <div class="flex justify-center items-center">-->
<!--                            <div class="m-2">-->
<!--                                <vs-button @click="updateReport()" :disabled="buttonDisabled">-->
<!--                                    Atualizar-->
<!--                                </vs-button>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </vs-card>-->
<!--            </vs-tab>-->
        </vs-tabs>

        <div class="vx-row" v-if="reportUser === 'specific' && currentTab !== 1">
            <vs-card>
                <div>
                    <users-table @chooseUser="chooseUser" :selected-users="selectedUsers" />
                </div>
            </vs-card>
        </div>

        <iframe
            v-if="currentTab !== 5"
            class="iframe1"
            :src="iframeUrl"
            allowtransparency
            scrolling="no"
        ></iframe>
    </div>
</template>

<script>

import jwt from 'jsonwebtoken';
import vSelect from 'vue-select'
import 'flatpickr/dist/flatpickr.css';
import {getCurrentTenant} from "@/utils";
import UsersTable from './UsersTable.vue'
import reportHttp from '@/http/requests/report'
import flatPickr from 'vue-flatpickr-component';
import VxTimeline from "@/components/timeline/VxTimeline"
import ReportBookingModal from './ReportBookingModal/ReportBookingModal.vue'

export default {
    data() {
        return {
            token: null,
            currentTab: 0,
            iframeUrl: null,
            reportUser: 'all',
            selectedUsers: [0],
            initial_date: null,
            finish_date: null,
            buttonDisabled: false,
            types: ['Atendimento', 'Campanha WhatsApp', 'Operador', 'Campanha Sms', 'Campanha Email'],
            typesNotIncludes: ['Operador'],
            typeSelected: 'Atendimento',
            dashboards: {
                attendance: { dashboard: 4 },
                campaignWhatsapp: { dashboard: 5 },
                operator: { dashboard: 6 },
                campaignSms: { dashboard: 15 },
                campaignEmail: { dashboard: 14 },
            },
            initialConfigdateTimePicker: {
                enableTime: false,
                noCalendar: false,
                dateFormat: 'd/m/Y',
                maxDate: new Date(),
                onChange: this.calendarChange
            },
            finalConfigdateTimePicker: {
                enableTime: false,
                noCalendar: false,
                minDate: null,
                maxDate: new Date(),
                dateFormat: 'd/m/Y',
            },
            payload: {
                resource: { },
                params: { },
                exp: Date.now() + (1000 * 60 * 60 * 24)
            }
        }
    },
    watch:{
        currentTab (){
            this.selectedUsers = [0]
            this.reportUser = 'all'
            this.filterDateAnalytics()
        },
        reportUser(reportUser){
            if (reportUser === 'all') {
                this.selectedUsers = [0]
            }
        },
        buttonDisabled(value) {
            if (value === true){
                setTimeout(() => {
                    this.buttonDisabled = false
                }, 1000)
            }
        }
    },
    computed: {
        initialDate(){
            return this.stringToDate(this.initial_date,"dd/MM/yyyy","/");
        },
        finishDate(){
            let finishedDate = this.stringToDate(this.finish_date,"dd/MM/yyyy","/")
            finishedDate.setHours(23,59,59, 9998)
            return finishedDate;
        },
        typeFilter(){
            return this.types.filter((value) => {
                return !value.includes(this.typesNotIncludes)
            });
        }
    },
    components: {
        VxTimeline,
        flatPickr,
        vSelect,
        UsersTable,
        ReportBookingModal
    },
    methods: {
        stringToDate(_date,_format,_delimiter){
            let formatLowerCase = _format.toLowerCase();
            let formatItems = formatLowerCase.split(_delimiter);
            let dateItems = _date.split(_delimiter);
            let dayIndex = formatItems.indexOf("dd");
            let monthIndex = formatItems.indexOf("mm");
            let yearIndex = formatItems.indexOf("yyyy");
            let month = parseInt(dateItems[monthIndex]);
            month-=1;

            return new Date(dateItems[yearIndex],month,dateItems[dayIndex]);
        },
        calendarChange(selectedDates) {
            this.finalConfigdateTimePicker.minDate = selectedDates[0]
        },
        filterDateAnalytics(){
            this.buttonDisabled = true;
            this.loadMetabase()
        },
        loadMetabase(){
            this.updatePayload()
            this.token = jwt.sign(this.payload,  process.env.VUE_APP_METABASE_SECRET_KEY, '', '');
            this.iframeUrl = process.env.VUE_APP_METABASE_SITE_URL + "/embed/dashboard/" + this.token + "#bordered=false&titled=false";
        },
        updatePayload() {
            if ( this.currentTab === 0 ){
                this.payload.resource = this.dashboards.attendance
            } else if (this.currentTab === 1) {
                this.payload.resource = this.dashboards.campaignWhatsapp
            } else if (this.currentTab === 2) {
                this.payload.resource = this.dashboards.operator
            }else if (this.currentTab === 3) {
                this.payload.resource = this.dashboards.campaignSms
            }else if (this.currentTab === 4) {
                this.payload.resource = this.dashboards.campaignEmail
            }

            this.payload.params = {
                'tenant': getCurrentTenant() + '.',
                'data_inicial' : this.initialDate,
                'data_final': this.finishDate,
                'user_id': this.selectedUsers.toString(),
                'tenant_ids': '0'
            }
        },
        chooseUser(userId) {
            const index = this.selectedUsers.indexOf(userId)
            if (index === -1) {
                this.selectedUsers.push(userId)
            } else {
                this.selectedUsers.splice(index, 1)
            }
        },
        formatToUsDate(date){
            return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
        },
        updateReport(){
            const from = this.formatToUsDate(this.initialDate);
            const to = this.formatToUsDate(this.finishDate);

            this.buttonDisabled = true;

            if (this.typeSelected === 'Atendimento'){
                return this.updateAttendance(from, to)
            } else if ( this.typeSelected === 'Campanha WhatsApp') {
                return this.updateCampaign(from, to)
            }else if ( this.typeSelected === 'Campanha Sms') {
                return this.updateCampaign(from, to)
            }else if ( this.typeSelected === 'Campanha Email') {
                return this.updateCampaign(from, to)
            }

            this.$vs.notify({
                color: 'danger',
                title: 'Relatório não informado.',
                text: `Necessário selecionar um tipo de relatório para prosseguir com a solicitação.`
            })
        },
        updateAttendance(from, to){
            reportHttp.syncAttendanceReport(from, to).then(res => {
                this.success('Atendimento')
            }).catch(err => { console.error(err) })
        },
        updateCampaign(from, to){
            reportHttp.syncCampaignReport(from, to).then(res => {
                this.success('Campanha WhatsApp')
                this.success('Campanha Sms')
                this.success('Campanha Email')
            }).catch(err => { console.error(err) })
        },
        success(type) {
            this.$vs.notify({
                color: 'success',
                title: 'Atualização',
                text: `A Atualização do Relatório ${type} foi solicitada com sucesso, orientamos que aguarde alguns minutos.`
            })
        },
        finishAtConfig(config) {
            return {
                ...config,
                minDate: this.start_at
            }
        }
    },
    beforeMount() {
        const today = new Date()
        const yyyy = today.getFullYear()
        const mm = String(today.getMonth() + 1).padStart(2, '0')
        const todayDay = String(today.getDate()).padStart(2, '0')

        this.initial_date = `${todayDay}/${mm}/${yyyy}`
        this.finish_date = `${todayDay}/${mm}/${yyyy}`
        this.loadMetabase();
    }
}
</script>

<style lang="scss">

#dashboard-analytics {
  .loading-dashboard-graphs {
    height: 11rem;
    width: 100%;
  }

  #vs-card{
    box-shadow: 0 4px 10px 0 rgba(0,0,0,.05) !important;
  }


  .iframe1{
    width: 100%;
    border: none;
    height: 60vw;
    display: block;
    overflow-y: auto;
    border-radius: 20px;
    overflow-x: hidden;
    box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
  }

  @media(max-width: 1230px) {
    .iframe1{
      height: 70vw !important;
    }
  }

  @media(max-width: 920px) {
    .iframe1{
      height: 90vw !important;
    }
  }

  @media(max-width: 750px) {
    .iframe1{
      height: 115vw !important;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
    .iframe1{
      height: 130vw !important;
    }
  }
}

</style>
